<template>
    <div
        :class="{ 'person--remove': owner.markedForDelete }"
        class="person"
    >
        <!-- TODO: Get remove button working -->
        <!-- TODO: Get #number to use ID from parent component -->

        <!-- Owner title -->
        <div class="d-flex justify-content-between">
            <h3 class="mb-5">
                Other Owner #<span>{{ number }}</span>
            </h3>
            <div>
                <button
                    type="button"
                    class="btn btn--outline btn--nomin btn--sm"
                    @click="$emit('delete', owner.property_owner_id, index)"
                >
                    {{ owner.markedForDelete ? 'Restore' : 'Remove' }}
                </button>
            </div>
        </div>

        <!-- Field: Owners -->
        <div
            v-if="options.length"
            class="field-wrap"
        >
            <h4 class="mb-3 color-mid-grey text-bold">
                Previously Added Owners
            </h4>
            <label
                :for="'field-added-owners-' + id"
                class="sr-only"
            >
                Owner
            </label>
            <div class="field-wrap__input field-wrap__input--select">
                <select
                    :id="'field-added-owners-' + id"
                    v-model="selectedOwner"
                    :disabled="owner.markedForDelete"
                    name="field-added-owners"
                    @change="selectOwner"
                >
                    <option
                        disabled
                        selected
                        hidden
                        value=""
                    >
                        Select an owner
                    </option>
                    <option
                        v-for="ownerChoice in options"
                        :key="ownerChoice.key"
                        :value="ownerChoice.id"
                    >
                        {{ ownerChoice.first_name }} {{ ownerChoice.last_name }} ({{ ownerChoice.email }})
                    </option>
                    <option value="new">
                        Add new owner
                    </option>
                </select>
            </div>
        </div>
        <!-- END Field: Owners -->

        <div v-if="selectedOwner === 'new'">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <!-- Field: Title -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Title
                        </h4>
                        <label
                            :for="'field-title' + id"
                            class="sr-only"
                        >
                            Title
                        </label>
                        <div class="field-wrap__input field-wrap__input--select">
                            <select
                                :id="'field-title-' + id"
                                v-model="owner.prefix"
                                :disabled="owner.markedForDelete"
                                name="field-title"
                            >
                                <option
                                    disabled
                                    selected
                                    hidden
                                >
                                    Select
                                </option>
                                <option>Mr.</option>
                                <option>Mrs.</option>
                                <option>Miss</option>
                                <option>Ms.</option>
                                <option>Dr.</option>
                            </select>
                        </div>
                    </div>
                    <!-- END Field: Title -->
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Field: DOB -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Date of Birth
                        </h4>
                        <label
                            :for="'field-dob-' + id"
                            class="sr-only"
                        >
                            Surname
                        </label>
                        <div class="field-wrap__input">
                            <input
                                :id="'field-dob-' + id"
                                v-model="owner.date_of_birth"
                                :disabled="owner.markedForDelete"
                                type="date"
                                name="field-dob"
                            >
                        </div>
                    </div>
                    <!-- END Field: DOB -->
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <!-- Field: Forename -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Forename
                        </h4>
                        <label
                            :for="'field-forename-' + id"
                            class="sr-only"
                        >
                            Forename
                        </label>
                        <div class="field-wrap__input">
                            <input
                                :id="'field-forename-' + id"
                                v-model="owner.first_name"
                                :disabled="owner.markedForDelete"
                                type="text"
                                name="field-forename"
                                placeholder="Forename"
                            >
                        </div>
                    </div>
                    <!-- END Field: Forename -->
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Field: Surname -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Surname
                        </h4>
                        <label
                            :for="'field-surname-' + id"
                            class="sr-only"
                        >
                            Surname
                        </label>
                        <div class="field-wrap__input">
                            <input
                                :id="'field-surname-' + id"
                                v-model="owner.last_name"
                                :disabled="owner.markedForDelete"
                                type="text"
                                name="field-surname"
                                placeholder="Surname"
                            >
                        </div>
                    </div>
                    <!-- END Field: Surname -->
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <!-- Field: Email -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Email Address
                        </h4>
                        <label
                            :for="'field-email-' + id"
                            class="sr-only"
                        >
                            Email Address
                        </label>
                        <div class="field-wrap__input">
                            <input
                                :id="'field-email-' + id"
                                v-model="owner.email"
                                :disabled="owner.markedForDelete"
                                type="text"
                                name="field-email"
                                placeholder="Email Address"
                            >
                        </div>
                    </div>
                    <!-- END Field: Email -->
                </div>
                <div class="col-12 col-lg-6">
                    <!-- Field: Telephone -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Telephone
                        </h4>
                        <label
                            :for="'field-mobiletel-' + id"
                            class="sr-only"
                        >
                            Telephone
                        </label>
                        <div class="field-wrap__input">
                            <input
                                :id="'field-mobiletel-' + id"
                                v-model="owner.telephone"
                                :disabled="owner.markedForDelete"
                                type="text"
                                name="field-mobiletel"
                                placeholder="Mobile Telephone"
                            >
                        </div>
                    </div>
                    <!-- END Field: Telephone -->
                </div>
                <div class="col-12">
                    <!-- Field: Notes -->
                    <div class="field-wrap">
                        <h4 class="mb-3 color-mid-grey text-bold">
                            Notes
                        </h4>
                        <label
                            :for="'field-mobiletel-' + id"
                            class="sr-only"
                        >
                            Notes
                        </label>
                        <div class="field-wrap__input">
                            <textarea
                                :id="'field-notes-' + id"
                                v-model="owner.notes"
                                :disabled="owner.markedForDelete"
                                name="field-notes"
                                placeholder="Add any notes about owner here"
                            />
                        </div>
                    </div>
                    <!-- END Field: Notes -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cloneDeep, uniqueId } from 'lodash-es';

export default {
    name: 'OwnersRepeater',
    props: {
        index: {
            type: Number,
            required: true
        },
        owner: {
            type: Object,
            required: true
        },
        owners: {
            type: Array,
            required: true
        },
        existingOwners: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            id: '0',
            selectedOwner: '',
            options: []
        };
    },
    computed: {
        number() {
            return (this.index + 1);
        }
    },
    watch: {
        owners(newOwners) {
            this.generateOptions(newOwners);
        }
    },
    created() {
        this.id = uniqueId();
    },
    mounted() {
        this.generateOptions(this.owners);
        if (!this.existingOwners.length) {
            this.selectedOwner = 'new';
        }
        else if (this.owner && this.owner.id) {
            this.selectedOwner = this.owner.id;
        }
    },
    methods: {
        generateOptions(owners) {
            this.options = [
                this.owner,
                ...this.existingOwners.filter(existingOwner => existingOwner.id !== this.owner.id && owners.findIndex(owner => owner.id === existingOwner.id) === -1)
            ].filter(item => item.existing);
            if (!this.options.length) {
                this.selectedOwner = 'new';
            }
        },
        selectOwner(e) {
            if (e.target.value !== 'new') {
                this.$emit('output', this.existingOwners.find(item => item.id === parseInt(e.target.value, 10)));
            }
        }
    }
};
</script>

<style lang="scss">
// Person (other owners)
.person {
    padding: 3rem;
    border: 1px solid darken(theme-color('light-grey'), 10%);
    border-radius: global-var('rounded-corners');
    margin-bottom: 3rem;

    &--remove {
        .field-wrap {
            opacity: 0.2;
        }
    }
}
</style>
